export default __webpack_public_path__ + "static/media/TaskManager.ce351bf3.svg";